var _g, _g2, _g3, _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    width: 1076.25,
    height: 1076.25,
    viewBox: "0 0 1076.25 1076.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(44.84375)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,1c1.1,0,2,0.9,2,2v18c0,1.1-0.9,2-2,2H3c-1.1,0-2-0.9-2-2V3c0-1.1,0.9-2,2-2H21 M21,0H3C1.34,0,0,1.34,0,3v18  c0,1.66,1.34,3,3,3h18c1.66,0,3-1.34,3-3V3C24,1.34,22.66,0,21,0L21,0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(275.625,107.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(296.625,107.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(338.625,107.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(380.625,107.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(401.625,107.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(443.625,107.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(464.625,107.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(548.625,107.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(590.625,107.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(653.625,107.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(674.625,107.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(716.625,107.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(737.625,107.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(758.625,107.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(779.625,107.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(275.625,128.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(443.625,128.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(464.625,128.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(485.625,128.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(569.625,128.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(590.625,128.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(695.625,128.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(716.625,128.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(779.625,128.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(275.625,149.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(317.625,149.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(359.625,149.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(443.625,149.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(464.625,149.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(485.625,149.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(506.625,149.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(527.625,149.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(569.625,149.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(611.625,149.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(653.625,149.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(695.625,149.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(716.625,149.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(737.625,149.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(317.625,170.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(338.625,170.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(359.625,170.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(380.625,170.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(401.625,170.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(485.625,170.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(506.625,170.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(548.625,170.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(569.625,170.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(590.625,170.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(674.625,170.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(758.625,170.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(317.625,191.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(401.625,191.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(422.625,191.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(443.625,191.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(464.625,191.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(485.625,191.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(548.625,191.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(569.625,191.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(590.625,191.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(653.625,191.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(695.625,191.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(737.625,191.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(758.625,191.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(779.625,191.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(275.625,212.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(296.625,212.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(317.625,212.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(443.625,212.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(464.625,212.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(527.625,212.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(569.625,212.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(674.625,212.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(695.625,212.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(716.625,212.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(779.625,212.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(275.625,233.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(317.625,233.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(359.625,233.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(401.625,233.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(443.625,233.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(485.625,233.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(527.625,233.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(569.625,233.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(611.625,233.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(653.625,233.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(695.625,233.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(737.625,233.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(779.625,233.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(275.625,254.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(317.625,254.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(422.625,254.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(548.625,254.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(569.625,254.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(590.625,254.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(653.625,254.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(695.625,254.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(758.625,254.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(779.625,254.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(149.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(170.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(191.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(233.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(275.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(296.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(317.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(338.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(422.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(443.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(527.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(548.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(569.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(611.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(716.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(758.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(779.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(800.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(821.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(842.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(905.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(926.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(947.625,275.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(107.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(128.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(191.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(275.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(338.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(359.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(380.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(401.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(422.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(485.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(506.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(548.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(695.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(716.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(758.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(779.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(800.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(821.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(842.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(863.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(905.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(926.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(947.625,296.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(149.625,317.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(233.625,317.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(275.625,317.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(317.625,317.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(422.625,317.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(443.625,317.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(527.625,317.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(569.625,317.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(611.625,317.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(653.625,317.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(674.625,317.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(779.625,317.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(821.625,317.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(863.625,317.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(926.625,317.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(128.625,338.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(170.625,338.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(191.625,338.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(254.625,338.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(296.625,338.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(317.625,338.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(380.625,338.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(401.625,338.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(422.625,338.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(464.625,338.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(590.625,338.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(632.625,338.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(695.625,338.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(758.625,338.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(779.625,338.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(800.625,338.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(821.625,338.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(863.625,338.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(884.625,338.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(926.625,338.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(149.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(191.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(212.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(233.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(275.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(296.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(317.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(338.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(359.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(380.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(422.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(443.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(464.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(485.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(506.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(548.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(590.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(611.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(674.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(716.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(737.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(758.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(779.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(821.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(884.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(905.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(926.625,359.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(128.625,380.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(149.625,380.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(191.625,380.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(212.625,380.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(317.625,380.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(338.625,380.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(380.625,380.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(485.625,380.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(527.625,380.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(590.625,380.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(653.625,380.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(674.625,380.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(695.625,380.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(737.625,380.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(800.625,380.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(842.625,380.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(863.625,380.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(884.625,380.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(926.625,380.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(947.625,380.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(107.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(128.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(149.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(170.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(191.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(233.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(275.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(317.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(338.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(359.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(380.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(464.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(485.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(506.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(527.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(548.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(590.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(611.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(779.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(800.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(842.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(884.625,401.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(128.625,422.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(149.625,422.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(212.625,422.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(296.625,422.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(317.625,422.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(359.625,422.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(401.625,422.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(443.625,422.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(485.625,422.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(548.625,422.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(590.625,422.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(611.625,422.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(653.625,422.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(695.625,422.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(737.625,422.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(821.625,422.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(842.625,422.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(884.625,422.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(107.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(128.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(170.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(191.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(233.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(254.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(338.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(359.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(380.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(422.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(443.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(485.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(506.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(569.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(590.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(611.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(632.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(716.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(737.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(800.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(842.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(905.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(926.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(947.625,443.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(128.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(149.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(191.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(212.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(401.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(422.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(443.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(506.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(548.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(569.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(590.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(611.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(632.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(653.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(695.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(758.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(779.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(821.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(842.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(863.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(884.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(905.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(926.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(947.625,464.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(107.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(233.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(275.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(317.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(443.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(464.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(485.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(506.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(527.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(548.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(569.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(590.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(611.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(632.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(653.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(674.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(737.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(779.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(800.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(821.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(863.625,485.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(275.625,506.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(359.625,506.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(380.625,506.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(401.625,506.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(485.625,506.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(569.625,506.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(590.625,506.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(758.625,506.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(779.625,506.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(821.625,506.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(863.625,506.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(884.625,506.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(947.625,506.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(107.625,527.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(128.625,527.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(191.625,527.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(233.625,527.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(254.625,527.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(275.625,527.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(380.625,527.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(422.625,527.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(443.625,527.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(464.625,527.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(506.625,527.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(632.625,527.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(653.625,527.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(737.625,527.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(758.625,527.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(800.625,527.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(863.625,527.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(905.625,527.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(926.625,527.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(107.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(149.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(170.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(191.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(317.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(338.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(380.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(401.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(485.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(506.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(527.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(548.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(569.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(695.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(758.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(779.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(800.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(821.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(863.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(884.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(905.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(926.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(947.625,548.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(128.625,569.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(191.625,569.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(212.625,569.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(233.625,569.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(359.625,569.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(401.625,569.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(443.625,569.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(485.625,569.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(527.625,569.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(569.625,569.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(590.625,569.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(653.625,569.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(674.625,569.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(716.625,569.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(779.625,569.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(800.625,569.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(821.625,569.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(863.625,569.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(884.625,569.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(149.625,590.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(170.625,590.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(212.625,590.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(254.625,590.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(317.625,590.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(338.625,590.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(380.625,590.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(443.625,590.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(485.625,590.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(506.625,590.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(653.625,590.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(758.625,590.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(800.625,590.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(863.625,590.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(926.625,590.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(128.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(170.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(191.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(233.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(254.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(275.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(338.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(359.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(380.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(401.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(443.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(464.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(506.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(527.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(548.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(569.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(611.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(632.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(653.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(674.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(716.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(842.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(926.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(947.625,611.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(149.625,632.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(170.625,632.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(212.625,632.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(254.625,632.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(317.625,632.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(401.625,632.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(443.625,632.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(464.625,632.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(485.625,632.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(506.625,632.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(548.625,632.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(569.625,632.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(611.625,632.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(695.625,632.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(716.625,632.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(758.625,632.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(821.625,632.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(842.625,632.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(863.625,632.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(884.625,632.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(107.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(128.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(149.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(170.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(233.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(254.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(275.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(296.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(359.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(380.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(401.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(464.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(485.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(527.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(569.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(590.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(632.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(653.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(674.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(716.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(779.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(800.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(926.625,653.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(107.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(128.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(149.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(170.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(191.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(212.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(317.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(338.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(359.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(422.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(443.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(464.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(527.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(590.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(653.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(695.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(758.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(779.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(842.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(884.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(926.625,674.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(128.625,695.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(170.625,695.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(191.625,695.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(233.625,695.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(275.625,695.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(296.625,695.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(338.625,695.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(380.625,695.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(485.625,695.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(632.625,695.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(653.625,695.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(695.625,695.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(716.625,695.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(758.625,695.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(800.625,695.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(884.625,695.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(905.625,695.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(107.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(128.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(149.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(191.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(212.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(254.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(275.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(317.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(338.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(359.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(380.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(401.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(443.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(464.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(527.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(548.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(569.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(590.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(632.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(653.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(674.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(716.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(779.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(842.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(863.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(926.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(947.625,716.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(107.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(149.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(191.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(233.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(254.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(317.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(338.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(359.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(422.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(443.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(485.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(527.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(548.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(569.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(590.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(611.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(632.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(674.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(695.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(758.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(800.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(821.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(842.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(905.625,737.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(107.625,758.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(149.625,758.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(212.625,758.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(338.625,758.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(380.625,758.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(401.625,758.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(443.625,758.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(464.625,758.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(569.625,758.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(590.625,758.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(674.625,758.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(758.625,758.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(779.625,758.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(800.625,758.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(821.625,758.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(842.625,758.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(884.625,758.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(926.625,758.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(947.625,758.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(107.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(170.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(212.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(233.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(338.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(359.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(401.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(422.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(485.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(527.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(548.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(569.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(590.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(611.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(653.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(674.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(695.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(737.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(758.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(779.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(800.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(821.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(842.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(863.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(905.625,779.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(275.625,800.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(317.625,800.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(338.625,800.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(359.625,800.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(401.625,800.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(422.625,800.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(443.625,800.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(464.625,800.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(485.625,800.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(548.625,800.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(611.625,800.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(716.625,800.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(758.625,800.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(779.625,800.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(863.625,800.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(884.625,800.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(926.625,800.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(947.625,800.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(317.625,821.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(338.625,821.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(359.625,821.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(380.625,821.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(401.625,821.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(443.625,821.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(464.625,821.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(632.625,821.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(653.625,821.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(674.625,821.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(716.625,821.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(758.625,821.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(779.625,821.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(821.625,821.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(863.625,821.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(884.625,821.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(296.625,842.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(485.625,842.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(527.625,842.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(569.625,842.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(590.625,842.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(611.625,842.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(674.625,842.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(716.625,842.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(737.625,842.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(779.625,842.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(863.625,842.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(275.625,863.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(296.625,863.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(317.625,863.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(338.625,863.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(380.625,863.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(401.625,863.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(506.625,863.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(569.625,863.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(590.625,863.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(632.625,863.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(674.625,863.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(695.625,863.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(779.625,863.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(800.625,863.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(821.625,863.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(842.625,863.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(863.625,863.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(905.625,863.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(926.625,863.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(275.625,884.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(296.625,884.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(317.625,884.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(359.625,884.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(380.625,884.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(422.625,884.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(443.625,884.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(527.625,884.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(632.625,884.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(653.625,884.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(695.625,884.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(737.625,884.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(800.625,884.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(842.625,884.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(926.625,884.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(947.625,884.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(275.625,905.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(296.625,905.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(338.625,905.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(359.625,905.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(380.625,905.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(422.625,905.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(464.625,905.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(485.625,905.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(506.625,905.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(548.625,905.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(611.625,905.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(674.625,905.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(716.625,905.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(800.625,905.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(821.625,905.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(842.625,905.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(863.625,905.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(926.625,905.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(296.625,926.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(317.625,926.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(338.625,926.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(359.625,926.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(380.625,926.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(401.625,926.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(422.625,926.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(443.625,926.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(485.625,926.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(569.625,926.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(632.625,926.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(653.625,926.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(674.625,926.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(779.625,926.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(821.625,926.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(863.625,926.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(905.625,926.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(926.625,926.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(317.625,947.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(380.625,947.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(401.625,947.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(422.625,947.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(506.625,947.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(548.625,947.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(569.625,947.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(611.625,947.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(632.625,947.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(653.625,947.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(674.625,947.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    transform: "translate(716.625,947.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(737.625,947.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(758.625,947.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(800.625,947.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "",
    transform: "translate(821.625,947.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(842.625,947.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#922731",
    transform: "translate(863.625,947.625) scale(3.605)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.625,107.625)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,14h5.1C12,14,14,12,14,9.6V4.5C14,2,12,0,9.5,0H4.4C2,0,0,2,0,4.4v5.1C0,12,2,14,4.5,14z M12,4.8v4.4 c0,1.5-1.3,2.8-2.8,2.8H4.8C3.2,12,2,10.8,2,9.2V4.8C2,3.3,3.3,2,4.8,2h4.4C10.8,2,12,3.2,12,4.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(821.625,107.625)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,14h5.1C12,14,14,12,14,9.6V4.5C14,2,12,0,9.5,0H4.4C2,0,0,2,0,4.4v5.1C0,12,2,14,4.5,14z M12,4.8v4.4 c0,1.5-1.3,2.8-2.8,2.8H4.8C3.2,12,2,10.8,2,9.2V4.8C2,3.3,3.3,2,4.8,2h4.4C10.8,2,12,3.2,12,4.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.625,821.625)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,14h5.1C12,14,14,12,14,9.6V4.5C14,2,12,0,9.5,0H4.4C2,0,0,2,0,4.4v5.1C0,12,2,14,4.5,14z M12,4.8v4.4 c0,1.5-1.3,2.8-2.8,2.8H4.8C3.2,12,2,10.8,2,9.2V4.8C2,3.3,3.3,2,4.8,2h4.4C10.8,2,12,3.2,12,4.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.625,149.625)",
    fill: "#922731"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,1.7v2.7C6,5.2,5.2,6,4.3,6H1.7C0.7,6,0,5.3,0,4.3V1.7C0,0.8,0.8,0,1.7,0h2.7C5.3,0,6,0.7,6,1.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(863.625,149.625)",
    fill: "#922731"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,1.7v2.7C6,5.2,5.2,6,4.3,6H1.7C0.7,6,0,5.3,0,4.3V1.7C0,0.8,0.8,0,1.7,0h2.7C5.3,0,6,0.7,6,1.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.625,863.625)",
    fill: "#922731"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,1.7v2.7C6,5.2,5.2,6,4.3,6H1.7C0.7,6,0,5.3,0,4.3V1.7C0,0.8,0.8,0,1.7,0h2.7C5.3,0,6,0.7,6,1.7z"
  }))))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPScjMDAwMDAwJyB3aWR0aD0iNjY2LjY2NjY4IiBoZWlnaHQ9IjY2Ni42NjcxNyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiPgogPGRlZnMgaWQ9ImRlZnMxMyI+CiAgPGNsaXBQYXRoIGlkPSJjbGlwUGF0aDI1IiBjbGlwUGF0aFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgIDxwYXRoIGlkPSJwYXRoMjMiIGQ9Im0wLDcwMGw3MDAsMGwwLC03MDBsLTcwMCwwbDAsNzAweiIvPgogIDwvY2xpcFBhdGg+CiA8L2RlZnM+CiAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMS4zMzMzMzMzLDAsMCwtMS4zMzMzMzMzLC0xMzMuMzMzMzMsNzk5Ljk5OTk5KSIgaWQ9ImcxNyI+CiAgICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcFBhdGgyNSkiIGlkPSJnMjEiPgogICAgICA8cGF0aCBmaWxsLXJ1bGU9Im5vbnplcm8iIGZpbGw9IiMwMDAwMDAiIGlkPSJwYXRoMjkiIGQ9Im02MDAsMzUwYzAsMTM4LjA3MSAtMTExLjkyOSwyNTAgLTI1MCwyNTBjLTEzOC4wNzEsMCAtMjUwLC0xMTEuOTI5IC0yNTAsLTI1MGMwLC0xMTcuMjQ1IDgwLjcxNSwtMjE1LjYyMiAxODkuNjA2LC0yNDIuNjM4bDAsMTY2LjI0MmwtNTEuNTUyLDBsMCw3Ni4zOTZsNTEuNTUyLDBsMCwzMi45MTljMCw4NS4wOTIgMzguNTA4LDEyNC41MzIgMTIyLjA0OCwxMjQuNTMyYzE1LjgzOCwwIDQzLjE2NywtMy4xMDUgNTQuMzQ3LC02LjIxMWwwLC02OS4yNTRjLTUuOTAxLDAuNjIxIC0xNi4xNDksMC45MzIgLTI4Ljg4MiwwLjkzMmMtNDAuOTkzLDAgLTU2LjgzMiwtMTUuNTI4IC01Ni44MzIsLTU1LjlsMCwtMjcuMDE4bDgxLjY1OSwwbC0xNC4wMjgsLTc2LjM5NmwtNjcuNjMxLDBsMCwtMTcxLjc3M2MxMjMuNzg2LDE0Ljk1MSAyMTkuNzEzLDEyMC4zNTEgMjE5LjcxMywyNDguMTY5Ii8+CiAgICAgIDxwYXRoIGZpbGwtcnVsZT0ibm9uemVybyIgZmlsbD0iI2ZmZmZmZiIgaWQ9InBhdGgzMyIgZD0ibTQ0Ny45MTc1MSwyNzMuNjAzNjFsMTQuMDI5LDc2LjM5NmwtODEuNjU5LDBsMCwyNy4wMTljMCw0MC4zNzIgMTUuODM4LDU1Ljg5OSA1Ni44MzEsNTUuODk5YzEyLjczMywwIDIyLjk4MSwtMC4zMSAyOC44ODIsLTAuOTMxbDAsNjkuMjUzYy0xMS4xOCwzLjEwNiAtMzguNTA5LDYuMjEyIC01NC4zNDcsNi4yMTJjLTgzLjUzOSwwIC0xMjIuMDQ4LC0zOS40NDEgLTEyMi4wNDgsLTEyNC41MzNsMCwtMzIuOTE5bC01MS41NTIsMGwwLC03Ni4zOTZsNTEuNTUyLDBsMCwtMTY2LjI0MmMxOS4zNDMsLTQuNzk4IDM5LjU2OCwtNy4zNjIgNjAuMzk0LC03LjM2MmMxMC4yNTQsMCAyMC4zNTgsMC42MzIgMzAuMjg4LDEuODMxbDAsMTcxLjc3M2w2Ny42MywweiIvPgogICA8L2c+CiAgPC9nPgo8L3N2Zz4=",
    width: 273,
    height: 273,
    x: 401.625,
    y: 401.625
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookQr);
export default __webpack_public_path__ + "static/media/facebookQR.99efa337f8d7215c0959f618f6566e1c.svg";
export { ForwardRef as ReactComponent };